import { useContext, useEffect, useState } from "react";
import "./style/RelifeClass.css";
import { NavLink, Link } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../auth/AuthProvider";
import Animation from "../animation/Animation.jsx";
import Themes from "../themes/Themes.jsx";

export default function RelifeClass({ leyebrow, lh2, lbody }) {
  return (
    <>
      <section id="relifeClass">
        <Animation effect={"show"} elementAppear={".relifeClassTitle"}>
          <div className="relifeClassTitle">
            <div>
              <div className="l-rule" />
              <span className="l-eyebrow" id="l-eyebrow">
                {leyebrow}
              </span>
            </div>
            <h2 className="l-h2">{lh2}</h2>
            <p className="l-body">{lbody}</p>
          </div>
        </Animation>
        {/* <Animation effect={"class"} elementAppear={"#relifeClassChild"}> */}
        <Themes />
        {/* </Animation> */}

        <div className="themes-view-all">
          <a href="/session">
            <button className="themes-view-all-btn">Browse all themes →</button>
          </a>
        </div>
      </section>
    </>
  );
}
